import moment from 'moment';
import JobCard from './JobCard';

const CalendarEvent = ({ event }) => {
    const dayOfWeek = moment(event.start).day();
    const chipPosition = dayOfWeek === 0 ? 'right' : 'left';
    const job = event.resource || event;

    // Check if this job is from a previous day (for gray background)
    const today = moment().startOf('day');
    const jobDate = moment(event.start).startOf('day');
    const isPreviousDay = jobDate.isBefore(today);

    return (
        <JobCard
            job={job}
            onClick={() => {}}
            chipPosition={chipPosition}
            isPreviousDay={isPreviousDay}
            currentView="month"
        />
    );
};

export default CalendarEvent;